// frontend/src/pages/PayrollDone/components/PageFooter.tsx
// Fixed bottom footer with Back, Export CSV, and Print all pay stubs actions.
// Pure presentation: parent owns what each callback does.

import React from "react";
import { ArrowLeft } from "lucide-react";
import { C, outlineBtn, primaryBtn } from "../styles";

interface PageFooterProps {
  onBack: () => void;
  onExportCsv: () => void;
  onPrintAll: () => void;
}

export default function PageFooter({
  onBack,
  onExportCsv,
  onPrintAll,
}: PageFooterProps): React.ReactElement {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 32px",
        borderTop: "1px solid " + C.line,
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: C.card,
        zIndex: 100,
        boxShadow: "0 -4px 12px rgba(0,0,0,0.06)",
      }}
    >
      <button
        onClick={onBack}
        style={{ ...outlineBtn, display: "inline-flex", alignItems: "center", gap: 6 }}
      >
        <ArrowLeft size={16} strokeWidth={2.5} />
        Back to Payroll
      </button>

      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={onExportCsv} style={outlineBtn}>
          Export CSV
        </button>
        <button onClick={onPrintAll} style={primaryBtn}>
          Print all pay stubs
        </button>
      </div>
    </div>
  );
}